import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className={`${icon} text-3xl`}></i>
      </div>
      <h3 className="text-base font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-600">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}